<!-- --------------------------- ANGULAR OUTLET ---------------------------- -->
<router-outlet></router-outlet>
<!-- -------------------------- ANGULAR JS OUTLET -------------------------- -->
<div ui-view></div>
<!-- --------------------------------- // ---------------------------------- -->
